/* =========================================================
   자영업 · 소상공인 홈페이지 랜딩 (/for/website) — 문구 단일 출처
   제품 개발 세그먼트와 구성이 달라(옵션 A·B·C 없음) 별도 페이지로 둔다.
   가격 · 포함 범위는 본 사이트 /services/website 와 같은 출처(content.js
   WEBSITE_SERVICE)를 쓰므로 그쪽을 고치면 여기도 함께 바뀐다.
   ========================================================= */
import { WEBSITE_SERVICE } from "../content";

export const WEBSITE_SLUG = "website";

export const WEBSITE_LANDING = {
  seo: {
    title: "손님은 이제 AI에게 물어봅니다 — 블로그 광고보다 내 가게 홈페이지 | I.META",
    description:
      "검색이 포털에서 AI 질문으로 바뀌었습니다. AI는 홍보성 블로그 글보다 사업자 정보·메뉴·가격·사진이 정리된 공식 홈페이지를 1차 출처로 보고 추천합니다. 자영업 가게 홈페이지, AI·검색엔진 기본 세팅까지 기본료 20만원부터.",
  },

  /* 핵심 메시지 — 검색이 포털에서 AI 질문으로 바뀌었고, 그래서 블로그보다 내 홈페이지가 유리하다 */
  hero: {
    kicker: "검색이 바뀌었습니다",
    title: "손님은 이제 검색하지 않고,\nAI에게 물어봅니다",
    lead:
      "요즘 손님은 네이버 검색창 대신 챗GPT 같은 AI에게 바로 묻습니다. 그리고 AI는 홍보성 블로그 글보다, 진짜 사업자 정보와 메뉴 · 가격 · 공간 사진이 정리된 가게의 공식 홈페이지를 1차 출처로 보고 추천합니다.",
    punch: "블로그 광고보다 내 홈페이지가 유리해진 이유입니다.",
    chips: ["AI · 검색엔진 기본 세팅", "매달 강요하는 관리비 없음", WEBSITE_SERVICE.price],
    /* 히어로 오른쪽 AI 대화 예시 — 가게 · 주소는 가상의 예시 */
    chat: {
      question: "OO동에 주차 편하고 단체 모임 하기 좋은 곳 추천해 줘",
      answer: "OO갈비를 추천합니다. 공식 홈페이지에 따르면 전용 주차장이 있고, 최대 40명 단체석과 전화 · 온라인 예약을 안내하고 있습니다.",
      source: "출처 · OO갈비 공식 홈페이지",
      note: "AI 검색 답변 예시",
    },
  },

  /* 포털 검색 → AI 질문 */
  shift: {
    title: "포털 검색에서 AI 질문으로,\n손님이 가게를 찾는 길이 바뀌었습니다",
    before: {
      label: "예전 · 포털 검색",
      steps: ["검색창에 'OO동 맛집' 입력", "광고 블로그 글이 수십 개", "손님이 직접 비교하고 의심"],
    },
    after: {
      label: "지금 · AI에게 질문",
      steps: ["\"주차 편하고 단체 모임 좋은 곳?\"", "AI가 가게 공식 정보를 읽고 정리", "조건에 맞는 가게를 바로 추천"],
    },
    key: "AI는 블로그 글이 아니라,\n가게의 공식 홈페이지를 1차 출처로 봅니다",
    points: [
      { title: "공식 사이트는 1차 출처", desc: "가게가 직접 밝힌 사업자 정보라서, 남이 쓴 광고 글보다 믿을 만한 근거로 쓰입니다." },
      { title: "정리된 정보가 추천받습니다", desc: "주차 · 단체석 · 영업시간 · 메뉴 · 가격처럼 손님이 묻는 내용이 한곳에 정리돼 있어야 AI가 답에 씁니다." },
      { title: "홍보 글은 힘이 약해집니다", desc: "AI로 찍어낸 비슷비슷한 체험단 글은 손님도, AI도 광고로 압니다. 근거로서 무게가 떨어집니다." },
    ],
  },

  /* 공감 — 광고 대행 · 체험단을 써 본 사장님들의 경험 */
  painsTitle: "그런데 아직도, 블로그 광고에\n매달 돈을 쓰고 계신가요?",
  pains: [
    {
      title: "광고비 낼 때만 반짝, 끊으면 뚝",
      desc: "\"상위 노출 보장\", \"체험단 10명에 얼마\". 매달 30만 원, 50만 원을 써도 광고를 멈추는 순간 방문자가 거짓말처럼 줄어듭니다.",
    },
    {
      title: "영혼 없는 리뷰만 줄줄이",
      desc: "AI로 대충 돌려 쓴 비슷비슷한 블로그 글. 이제 블로그 리뷰를 그대로 믿는 손님은 거의 없습니다.",
    },
    {
      title: "남는 건 가게 자산이 아니라 영수증",
      desc: "몇 달을 써도 내 이름으로 남는 게 없습니다. 쌓인 건 대행사 실적뿐, 다음 달에도 또 같은 돈을 내야 합니다.",
    },
  ],

  /* 블로그 광고 vs 내 홈페이지 */
  compare: {
    title: "월세 내는 광고 vs\n내 이름으로 남는 홈페이지",
    cols: ["블로그 광고 · 체험단", "내 가게 홈페이지"],
    rows: [
      ["비용", "매달 반복해서 나감", "한 번 만들어 계속 사용"],
      ["광고를 멈추면", "노출과 방문이 함께 사라짐", "주소와 정보가 그대로 남음"],
      ["손님이 보는 신뢰", "광고 글로 의심받기 쉬움", "가게가 직접 밝힌 공식 정보"],
      ["AI · 검색 노출", "비슷한 홍보 글 사이에 묻힘", "정확한 1차 출처로 읽힘"],
      ["누구의 자산인가", "플랫폼과 대행사", "사장님 가게"],
    ],
    math: {
      label: "블로그 광고 월 30만 원 × 12개월",
      value: "1년 360만 원",
      vs: "가게 홈페이지",
      vsValue: WEBSITE_SERVICE.price,
    },
  },

  /* 사장님께 필요한 건 딱 이 정도 */
  needs: {
    title: "수백만 원짜리 사이트가 아니라,\n딱 이 정도면 충분합니다",
    desc: "대기업 사이트를 만들 게 아닙니다. 손님이 가게를 찾고, 믿고, 연락하는 데 필요한 것만 담습니다.",
    items: [
      {
        icon: "Search",
        title: "AI · 검색엔진 기본 세팅",
        desc: "AI와 포털 검색엔진이 가게 이름 · 업종 · 주소 · 영업시간을 정확히 읽어 가도록 구조화 정보와 검색 등록을 기본으로 해 둡니다.",
      },
      {
        icon: "Globe",
        title: "어디든 걸어 두는 공식 링크",
        desc: "네이버 스마트플레이스, 인스타그램 프로필, 카카오톡 채널에 딱 걸어 둘 수 있는 내 가게 주소.",
      },
      {
        icon: "Doc",
        title: "시그니처 메뉴 · 가격 · 오시는 길",
        desc: "대표 메뉴와 서비스, 명확한 가격, 지도 · 주차 · 영업시간을 한 화면에서 알아보게 정리합니다.",
      },
      {
        icon: "Phone",
        title: "예약 · 문의로 바로 연결",
        desc: "휴대폰에서 누르면 바로 전화 · 문자 · 카카오톡 · 예약으로 이어지는 직관적인 화면.",
      },
    ],
  },

  /* 가격 — 거품 뺀 실속형 */
  price: {
    title: "거품 뺀 실속형 가격",
    desc: "수백만 원 견적, 관리비 명목으로 매달 나가는 돈 때문에 엄두가 안 나셨다면.",
    points: [
      "1:1 맞춤 제작 — 템플릿을 그대로 찍어내지 않습니다",
      "관리비 명목으로 매달 강요하는 비용 없음",
      "필요한 기능만 골라서 더하는 방식",
    ],
  },

  faq: [
    {
      q: "AI 검색이 정말 블로그보다 홈페이지를 보나요?",
      a: "AI는 답을 만들 때 믿을 만한 출처를 찾습니다. 가게가 직접 운영하는 공식 홈페이지에 사업자 정보 · 메뉴 · 가격 · 위치 · 영업시간이 정리돼 있으면, 비슷한 내용이 반복되는 홍보성 블로그 글보다 정확한 근거로 쓰이기 쉽습니다. 그래서 정보를 AI가 읽기 좋은 구조로 정리하는 기본 세팅을 함께 해 드립니다.",
    },
    {
      q: "비용은 얼마인가요?",
      a: `${WEBSITE_SERVICE.price}입니다. ${WEBSITE_SERVICE.priceNote} 상담과 견적은 무료입니다.`,
    },
    {
      q: "매달 관리비를 내야 하나요?",
      a: "관리비 명목으로 매달 비용을 강요하지 않습니다. 도메인(인터넷 주소)처럼 꼭 필요한 비용이 있으면 상담에서 미리 투명하게 안내드립니다.",
    },
    {
      q: "컴퓨터를 잘 몰라도 괜찮나요?",
      a: "네. 가게 사진, 메뉴판, 소개 몇 줄만 카카오톡이나 메일로 보내 주시면 나머지는 저희가 정리해서 만듭니다.",
    },
    {
      q: "스마트플레이스 · 인스타가 이미 있는데 필요할까요?",
      a: "그대로 쓰시면서 함께 걸어 두는 공식 링크가 됩니다. 플랫폼 안의 정보는 그 플랫폼 규칙에 묶이지만, 홈페이지는 사장님 가게의 정보를 사장님 방식대로 보여 주는 자리입니다.",
    },
    {
      q: "AI 검색이나 네이버 상위 노출을 보장하나요?",
      a: "노출 순위는 누구도 보장할 수 없고, 저희도 '상위 노출 보장' 같은 말은 하지 않습니다. 대신 AI와 검색엔진이 가게 정보를 정확히 읽어 갈 수 있도록 기본 세팅과 검색 등록을 빠짐없이 해 드립니다.",
    },
    {
      q: "메뉴나 가격이 바뀌면 어떻게 하나요?",
      a: "간단한 수정은 요청해 주시면 반영해 드립니다. 직접 자주 고치고 싶으시면 메뉴 · 가격을 바꿀 수 있는 관리 화면을 더할 수도 있습니다.",
    },
    {
      q: "광주가 아니어도 되나요?",
      a: "네. 자료는 온라인으로 받고 확인 · 수정도 온라인으로 진행하므로 지역과 상관없이 만들 수 있습니다.",
    },
  ],

  cta: {
    title: "큰돈 들이지 않고,\n내 가게의 온라인 간판 하나",
    desc: "꼭 의뢰가 아니어도 괜찮습니다. 가게 온라인 세팅이나 검색 등록 관련해 궁금한 점도 편하게 물어보세요.",
  },
};

/* 문의 폼 — 제품 개발 폼과 문구만 바꿔 같은 접수 API(/api/landing/inquiry)를 쓴다 */
export const WEBSITE_FORM = {
  title: "홈페이지 상담 문의",
  lead: "가게 이야기를 남겨 주시면 확인 후 연락드립니다. 상담과 견적은 무료입니다.",
  intro: "자세하지 않아도 괜찮습니다. 가게 이름과 업종만 적어 주셔도 됩니다.",
  ideaLabel: "가게 소개 · 원하는 내용",
  ideaPlaceholder:
    "예) 광주 OO동 OO카페입니다. 스마트플레이스·인스타는 있는데 메뉴와 가격, 단체 예약 안내를 담은 홈페이지가 필요합니다.",
  ideaError: "가게 이름이나 원하는 내용을 한두 줄이라도 적어주세요.",
  dueLabel: "희망 오픈 시점",
  duePlaceholder: "예: 다음 달 리뉴얼 오픈 전",
  fileHint: "가게 사진 · 메뉴판 · 로고 등",
  submit: "홈페이지 상담 보내기",
  done: "보내 주신 내용을 확인한 뒤",
  asideTitle: "문의 후에는 이렇게 진행됩니다",
  flow: WEBSITE_SERVICE.flow,
  noteTitle: "관리비 걱정 없이",
  note: "관리비 명목으로 매달 비용을 요구하지 않습니다. 필요한 비용은 상담에서 미리 투명하게 안내드립니다.",
};
